"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeNewChat = exports.maximizeChatFive9 = exports.minimizeChatFive9 = exports.setNewStatus = exports.setChatSession = exports.open = exports.initializeFive9Configuration = exports.loadScriptFive9Chat = exports.attributeListener = void 0;
var utils_1 = require("../utils");
var constants = require("./constants");
var chatEvents = require("./events");
var styles_1 = require("./styles");
var survey_1 = require("./survey");
var suscriptions_1 = require("./suscriptions");
var utils_2 = require("./utils");
var _1 = require(".");
var intersectionObserver;
function attributeListener() {
    var elementsFive9Chat = document.querySelectorAll("[class=".concat(constants.LOAD_TAG_FIVE9_CHAT, "]"));
    if (elementsFive9Chat.length == 0) {
        return console.warn("No se encontró elemento para observar y no se cargará el fichero de Five9");
    }
    var OBSERVER_OPTIONS = {
        root: null,
        rootMargin: "0px",
        threshold: [1],
    };
    intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting)
            requestIdleCallback(loadScriptFive9Chat);
    }, OBSERVER_OPTIONS);
    elementsFive9Chat.forEach(function (element) {
        intersectionObserver.observe(element);
    });
}
exports.attributeListener = attributeListener;
function loadScriptFive9Chat() {
    if (document.querySelector("#".concat(constants.ID_SCRIPT_FILE_FIVE9_CHAT)))
        return;
    var scriptElement = document.createElement("script");
    scriptElement.addEventListener("load", function () {
        (0, suscriptions_1.createSuscriptions)();
        chatEvents.dispatchChatEvent(chatEvents.FILE_LOADED_FIVE9_CHAT_EVENT);
    });
    scriptElement.addEventListener("error", function () {
        window.dispatchEvent(chatEvents.createCustomEvent(chatEvents.FILE_ERROR_LOADED_FIVE9_CHAT_EVENT, {
            detail: "No se pudo cargar el script de Five9, por favor vuelve a intentar actualizando la página.",
        }));
        scriptElement.remove();
    });
    scriptElement.id = constants.ID_SCRIPT_FILE_FIVE9_CHAT;
    scriptElement.src = constants.SCRIPT_FILE_FIVE9_CHAT;
    document.body.appendChild(scriptElement);
    intersectionObserver.disconnect();
}
exports.loadScriptFive9Chat = loadScriptFive9Chat;
function initializeFive9Configuration(configurations) {
    var _a;
    if (configurations === void 0) { configurations = {}; }
    if ((_a = configurations === null || configurations === void 0 ? void 0 : configurations.chat) === null || _a === void 0 ? void 0 : _a.strict) {
        (0, utils_1.removeLocalStorage)(utils_1.LOCAL_STORAGE_FIVE9_ITEM);
        chatEvents.dispatchChatEvent(chatEvents.CLOSE_FIVE9_CHAT_EVENT);
    }
    var chatStatus = (0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.status);
    if (!chatStatus || chatStatus == ChatModel.Steps.Unknown) {
        var defaultConfiguration = (0, utils_2.getDefaultConfiguration)();
        var customConfigurations = configurations && configurations.chat ? configurations.chat : {};
        var mergedConfigurations = (0, utils_1.merge)(defaultConfiguration, customConfigurations);
        (0, utils_1.setLocalStorageJSON)(utils_1.LOCAL_STORAGE_FIVE9_ITEM, {
            configurations: mergedConfigurations,
        });
    }
}
exports.initializeFive9Configuration = initializeFive9Configuration;
function open() {
    if (!(0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.status)) {
        var session = {
            status: ChatModel.Steps.Unknown,
            configurations: (0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.configurations),
        };
        (0, utils_1.setLocalStorageJSON)(utils_1.LOCAL_STORAGE_FIVE9_ITEM, session);
        chatEvents.dispatchChatEvent(chatEvents.CLOSE_FIVE9_CHAT_EVENT);
    }
    Five9SocialWidget.addWidget((0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.configurations));
    (0, styles_1.siigoStylesChat)();
    (0, survey_1.setURLSendSurvey)((0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.configurations).survey.urlSendSurvey);
    (0, styles_1.showChat)();
    var message = (0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.configurations).informationalMessage;
    if (message) {
        (0, _1.informationalMessage)(message);
    }
    if ((0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.status) == ChatModel.Steps.Finished) {
        chatEvents.dispatchChatEvent(chatEvents.OPEN_SURVEY_FIVE9_CHAT_EVENT);
    }
}
exports.open = open;
function setChatSession(_chatSession) {
    var session = {
        status: ChatModel.Steps.Finished,
        chatData: _chatSession,
        configurations: (0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.configurations),
    };
    (0, utils_1.setLocalStorageJSON)(utils_1.LOCAL_STORAGE_FIVE9_ITEM, session);
}
exports.setChatSession = setChatSession;
function setNewStatus(newStatus) {
    var five9ChatSession = JSON.parse((0, utils_1.getLocalStorage)(utils_1.LOCAL_STORAGE_FIVE9_ITEM) || "{}");
    five9ChatSession.status = newStatus;
    (0, utils_1.setLocalStorageJSON)(utils_1.LOCAL_STORAGE_FIVE9_ITEM, five9ChatSession);
}
exports.setNewStatus = setNewStatus;
function minimizeChatFive9() {
    var five9Chat = (0, utils_1.documentElementByClass)(constants.ID_FIVE9_FRAME_FULL);
    var five9MinimizedBubble = (0, utils_1.documentElementByClass)(constants.CLASS_FIVE9_BUBBLE);
    if (five9Chat && five9MinimizedBubble) {
        five9Chat.style.display = utils_1.CSS_STYLES.DISPLAY.NONE;
        five9MinimizedBubble.style.display = utils_1.CSS_STYLES.DISPLAY.BLOCK;
    }
}
exports.minimizeChatFive9 = minimizeChatFive9;
function maximizeChatFive9() {
    var five9Chat = (0, utils_1.documentElementByClass)(constants.ID_FIVE9_FRAME_FULL);
    var five9MinimizedBubble = (0, utils_1.documentElementByClass)(constants.CLASS_FIVE9_BUBBLE);
    if (five9Chat && five9MinimizedBubble) {
        five9Chat.style.display = utils_1.CSS_STYLES.DISPLAY.BLOCK;
        five9Chat.style.visibility = utils_1.CSS_STYLES.VISIBILITY.VISIBLE;
        five9MinimizedBubble.style.display = utils_1.CSS_STYLES.DISPLAY.NONE;
    }
}
exports.maximizeChatFive9 = maximizeChatFive9;
function initializeNewChat() {
    var configurations = {
        chat: (0, utils_1.merge)((0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.configurations), {
            strict: true,
        }),
    };
    chatEvents.dispatchChatEvent(chatEvents.INITIALIZE_CONFIGURATION_FIVE9_CHAT_EVENT, configurations);
    chatEvents.dispatchChatEvent(chatEvents.OPEN_FIVE9_CHAT_EVENT);
}
exports.initializeNewChat = initializeNewChat;
;
//# sourceMappingURL=chat.js.map